import axios from '../utils/axios';

export interface ApiPlan {
  id: number;
  name: string;
  slug: string;
  pricing_id: string | null;
  quota: number;
  cooldownHours: number;
  maxConcurrency: number;
  rateLimit: number;
  isFree: boolean;
  priceCents?: number;
  priceCurrency?: string;
  billingInterval?: string;
}

interface GetApiPlansResponse {
  success: boolean;
  plans: ApiPlan[];
}

interface CreateApiSubscriptionResponse {
  success: boolean;
  checkoutUrl?: string;
  sessionId?: string;
  apiKey?: string;
  keyId?: number;
  keyPrefix?: string;
  quota?: number;
  message: string;
}

interface PortalSessionResponse {
  success: boolean;
  portalUrl: string;
}

export const getApiPlans = async (): Promise<ApiPlan[]> => {
  const response = await axios.get<GetApiPlansResponse>('/plans', {
    params: { type: 'api' },
  });
  return response.data.plans;
};

export const createOrUpgradeApiSubscription = async ({
  planSlug,
  storeId,
  name,
}: {
  planSlug: string;
  storeId: number;
  name: string;
}): Promise<CreateApiSubscriptionResponse> => {
  const token = localStorage.getItem('token');
  const response = await axios.post<CreateApiSubscriptionResponse>(
    '/api-keys',
    { planSlug, storeId, name },
    {
      headers: token
        ? { Authorization: `Bearer ${token}` }
        : {},
    }
  );
  return response.data;
};

export const createApiPortalSession = async (): Promise<string> => {
  const token = localStorage.getItem('token');
  const response = await axios.post<PortalSessionResponse>(
    '/plans/portal-session',
    {},
    {
      headers: token
        ? { Authorization: `Bearer ${token}` }
        : {},
    }
  );
  return response.data.portalUrl;
};

/**
 * Get plan price in dollars from priceCents
 * @param plan - The API plan object with pricing data
 * @returns Price in dollars (e.g., 29 for $29.00)
 */
export const getPlanPrice = (plan: ApiPlan): number => {
  if (plan.isFree || !plan.priceCents) return 0;
  return plan.priceCents / 100;
};
